import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { service } from 'global/Models/omOrderModel';
import { setOrderService } from 'redux/reducer/ParcelOrder/parcelOrderReducer';

export const getServices = () => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.serviceGetAll, { recordsPerPage: 50 })
    .then((res: IBackendSearchGeneric<service>) => {
      res.isSuccess && dispatch(setOrderService(res.data));
    })
    .catch(() => {});
};
